var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReporting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_44_9734",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.437256,
    width: 24,
    height: 24,
    fill: "#ADB5BD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_44_9734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.20039 12.4373V10.0373H16.8004V12.4373H7.20039ZM7.20039 7.63726V5.23726H16.8004V7.63726H7.20039ZM4.80039 14.8373H13.8004C14.3804 14.8373 14.9204 14.9623 15.4204 15.2123C15.9204 15.4623 16.3404 15.8173 16.6804 16.2773L19.2004 19.5773V2.83726H4.80039V14.8373ZM4.80039 22.0373H18.0604L14.7904 17.7473C14.6704 17.5873 14.5254 17.4623 14.3554 17.3723C14.1854 17.2823 14.0004 17.2373 13.8004 17.2373H4.80039V22.0373ZM19.2004 24.4373H4.80039C4.14039 24.4373 3.57539 24.2023 3.10539 23.7323C2.63539 23.2623 2.40039 22.6973 2.40039 22.0373V2.83726C2.40039 2.17726 2.63539 1.61226 3.10539 1.14226C3.57539 0.672256 4.14039 0.437256 4.80039 0.437256H19.2004C19.8604 0.437256 20.4254 0.672256 20.8954 1.14226C21.3654 1.61226 21.6004 2.17726 21.6004 2.83726V22.0373C21.6004 22.6973 21.3654 23.2623 20.8954 23.7323C20.4254 24.2023 19.8604 24.4373 19.2004 24.4373Z",
    fill: "#ADB5BD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporting);
export default __webpack_public_path__ + "static/media/reporting.31f97b52f817bad03ccb26bf87b41e1a.svg";
export { ForwardRef as ReactComponent };